import camelCase from 'lodash/camelCase'

import defaultState from './state'

const format = (value, type) => {
  if (typeof value === 'string') {
    const minimumFractionDigits = [
      'heartRate',
      'diastolicPressure',
      'systolicPressure'
    ].includes(type)
      ? 0
      : 2

    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits
    }).format(value)
  }

  if (value) {
    const minimumFractionDigits = [
      'heartRate',
      'diastolicPressure',
      'systolicPressure'
    ].includes(type)
      ? 0
      : 2

    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits
    }).format(value / 1000)
  }
  return undefined
}

const setClinicalProfile = (state, clinicalProfile) => {
  const currentClinicalProfile = {
    ...state.currentClinicalProfile,
    ...clinicalProfile,
    height: format(clinicalProfile.height, 'height'),
    weight: format(clinicalProfile.weight, 'weight'),
    bodyFatPercentage: format(
      clinicalProfile.bodyFatPercentage,
      'bodyFatPercentage'
    ),
    skeletalMuscleMass: format(
      clinicalProfile.skeletalMuscleMass,
      'skeletalMuscleMass'
    ),
    heartRate: format(clinicalProfile.heartRate, 'heartRate'),
    diastolicPressure: format(
      clinicalProfile.diastolicPressure,
      'diastolicPressure'
    ),
    systolicPressure: format(
      clinicalProfile.systolicPressure,
      'systolicPressure'
    ),
    abdominalCircumference: format(
      clinicalProfile.abdominalCircumference,
      'abdominalCircumference'
    ),
    neckCircumference: format(
      clinicalProfile.neckCircumference,
      'neckCircumference'
    )
  }

  Object.assign(state, { currentClinicalProfile })
}

const setHealthMeasurementInfo = (state, { type, value }) => {
  const stateType = camelCase(type)
  state.currentClinicalProfile[stateType] = format(value, stateType)
}

const addClinicalBackgroundInfo = (
  state,
  { clinicalBackground, propertyName }
) => {
  state.currentClinicalProfile[propertyName].push(clinicalBackground)
}

const updateClinicalBackgroundInfo = (
  state,
  { clinicalBackground, propertyName }
) => {
  if (!state.currentClinicalProfile[`${propertyName}`]) {
    state.currentClinicalProfile = {
      ...state.currentClinicalProfile,
      [`${propertyName}`]: [clinicalBackground]
    }
    return
  }
  const infos = [...state.currentClinicalProfile[`${propertyName}`]]
  const index = infos.findIndex(it => it.id === clinicalBackground.id)
  if (index !== -1) {
    infos[index] = clinicalBackground
  }
  state.currentClinicalProfile = {
    ...state.currentClinicalProfile,
    [`${propertyName}`]: infos
  }
}

const removeClinicalBackgroundInfo = (
  state,
  { clinicalBackground, propertyName }
) => {
  const index = state.currentClinicalProfile[propertyName].findIndex(
    background => background.value === clinicalBackground.value
  )

  state.currentClinicalProfile[propertyName].splice(index, 1)
}

const formatMeasurement = measurement => {
  if (measurement === undefined) return '- -'
  return (+measurement).toFixed(2)
}

const formatIntegerMeasurement = measurement => {
  if (measurement === undefined) return '- -'
  return Math.floor(+measurement)
}

const setHealthMeasurements = (state, healthMeasurements = []) => {
  Object.assign(state, {
    healthMeasurements: healthMeasurements.map(item => ({
      ...item,
      bmi: formatMeasurement(item.bmi),
      bodyFatPercentage: formatMeasurement(item.bodyFatPercentage),
      date: item.date,
      diastolicPressure: formatIntegerMeasurement(item.diastolicPressure),
      heartRate: formatIntegerMeasurement(item.heartRate),
      height: formatMeasurement(item.height),
      skeletalMuscleMass: formatMeasurement(item.skeletalMuscleMass),
      systolicPressure: formatIntegerMeasurement(item.systolicPressure),
      weight: formatMeasurement(item.weight),
      abdominalCircumference: formatIntegerMeasurement(
        item.abdominalCircumference
      ),
      neckCircumference: formatIntegerMeasurement(item.neckCircumference),
      absByHeight: formatMeasurement(item.abdominalCircumferenceByHeight)
    }))
  })
}

const setHealthMeasurementTypes = (state, healthMeasurementTypes) => {
  Object.assign(state, { healthMeasurementTypes })
}

const setHealthMeasurementsTableData = (state, healthMeasurementsTableData) => {
  Object.assign(state, { healthMeasurementsTableData })
}

const resetState = state => {
  Object.assign(state, {
    ...defaultState()
  })
}

export default {
  setClinicalProfile,
  setHealthMeasurementInfo,
  addClinicalBackgroundInfo,
  updateClinicalBackgroundInfo,
  removeClinicalBackgroundInfo,
  setHealthMeasurements,
  setHealthMeasurementTypes,
  setHealthMeasurementsTableData,
  resetState
}
